<ng-container *ifStoreCreditCanBeUsed>
    @if (!storeCreditAdded) {
    <store-credit-apply class="block m-b-2"
                        [isCheckout]="isCheckout" />
    }
</ng-container>
<!-- coupon form -->
@if (displayCouponForm) {
<div class="b-radius-basket w-12 m-b-2 b-a b-col-4">
    <div class="b-radius-basket basket-addon w-12 flex flex-justify-between flex-middle p-a-2 cursor-pointer"
         [toggle]="[toggleGroup, couponToggleId]"
         [toggleClass]="'is-open bg-col-4'">
        <div>
            <i class="icon-percent fs-3 m-l-1"
               aria-hidden="true"></i>
            <span class="p-l-2 p2">{{'Apply promotional code' | translate}}</span>
        </div>
        <i class="icon-plus-animate fs-2 m-r-1"
           aria-hidden="true"></i>
    </div>
    <div [hideUp]="[toggleGroup, couponToggleId]">
        <coupon-form class="block"
                     [isCheckout]="isCheckout" />
    </div>
</div>
}
<!-- giftcard form -->
<div class="b-radius-basket w-12 m-b-2 b-a b-col-4">
    <div class="b-radius-basket basket-addon w-12 flex flex-justify-between flex-middle p-a-2 cursor-pointer"
         [toggle]="[toggleGroup, giftcardsToggleId]"
         [toggleClass]="'is-open bg-col-4'">
        <div>
            <i class="icon-cards m-l-1"
               aria-hidden="true"></i>
            <span class="p-l-2 p2">{{'Apply gift card' | translate}}</span>
        </div>
        <i class="icon-plus-animate fs-2 m-r-1"
           aria-hidden="true"></i>
    </div>
    <div [hideUp]="[toggleGroup, giftcardsToggleId]">
        <giftcards-form class="block"
                        [isCheckout]="isCheckout" />
    </div>
</div>
